/**
 * Основной модуль для работы страницы 'Карточка заболевания'
 *
 */
( function (global) {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
        new global.ImageOverlay('#preview_image').init();
    });

}(window));